import { CSSProperties } from "react";
import { FIGMA_COLORS } from "components-redesign/styles/colors";

const commonTextClasses: Record<string, CSSProperties> = {
  label: {
    cursor: "pointer",
    paddingLeft: "0",
    color: "rgba(0,0,0, 0.26)",
    fontSize: "14px",
    lineHeight: "1.428571429",
    fontWeight: "400",
    display: "inline-flex",
  },
  inputValue: {
    color: "#000",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "21px",
    letterSpacing: "0.131px",
  },
  errorText: {
    fontSize: "12px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    color: FIGMA_COLORS.errorLight,
  },
  warningText: {
    fontSize: "10px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
  inputUnderline: {
    borderBottom: `1px solid ${FIGMA_COLORS.outlineVariantDark}`,
  },
  balancedWrap: {
    overflowWrap: "break-word",
    wordBreak: "normal",
    textWrapStyle: "balance",
  },
};

export default commonTextClasses;
